import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'File Name',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'fileType',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOnText',
    filter: 'text',
    searchable: true,
  },
];
